import { render, staticRenderFns } from "./ListOrderCantServe.vue?vue&type=template&id=d765fae2"
import script from "./ListOrderCantServe.vue?vue&type=script&lang=js"
export * from "./ListOrderCantServe.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ListOrderCantServe.vue?vue&type=style&index=1&id=d765fae2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports